"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetDriver = exports.getClassnameExtends = exports.THEME_PRESET_CLASS_PREFIX = exports.USER_PRESET_CLASS_PREFIX = exports.STATIC_PRESET_CLASS_PREFIX = exports.THEME_PRESET_PROPNAME = void 0;
var core_1 = require("@stylable/core");
var stylable_variant_1 = require("./stylable-variant");
exports.THEME_PRESET_PROPNAME = '-editor-theme';
exports.STATIC_PRESET_CLASS_PREFIX = 'preset';
exports.USER_PRESET_CLASS_PREFIX = 'my-preset';
exports.THEME_PRESET_CLASS_PREFIX = 'theme-preset';
var DEFAULT_COMPONENT_NAME = 'unknown-comp';
var getClassnameExtends = function (sheet, sourceClassName) {
    var classSymbol;
    sheet.AST.walkRules("." + sourceClassName, function (rule) {
        rule.walkDecls(core_1.valueMapping.extends, function (decl) {
            classSymbol = decl.value;
        });
    });
    return classSymbol;
    // const classSymbol = meta.classes[sourceClassName];
    // if (!classSymbol) { return undefined; }
    // const extendingSymbol = classSymbol[valueMapping.extends];
    // if (!extendingSymbol || extendingSymbol._kind !== 'import') {
    //     return undefined;
    // } else {
    //     const _import = extendingSymbol.import;
    //     const extendsOriginName = extendingSymbol.name;
    //     if (extendingSymbol.type === 'default') {
    //         return _import.defaultExport;
    //     } else if (extendingSymbol.type === 'named') {
    //         return Object.keys(extendingSymbol.import.named).find(name => {
    //             return _import.named[name] === extendsOriginName;
    //         });
    //     }
    // }
};
exports.getClassnameExtends = getClassnameExtends;
var PresetDriver = /** @class */ (function () {
    function PresetDriver(params) {
        this.shouldRestorePreset = false;
        this.presetSheetPaths = [];
        this.presets = {
            staticPresets: params.presets || [],
            myPresets: [],
            themePresets: [],
        };
        this.stylableDriver = params.stylableDriver;
        this.componentName = params.componentName || DEFAULT_COMPONENT_NAME;
        this.sourceClassName = params.sourceClassName;
        this.extendsSymbol = params.extendsSymbol;
        this.snapshots = params.snapshots || [];
        this.initStylesheets(params);
    }
    Object.defineProperty(PresetDriver.prototype, "staticPresets", {
        get: function () {
            return this.presets.staticPresets;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PresetDriver.prototype, "firstSnapshot", {
        get: function () {
            return this.snapshots[0];
        },
        enumerable: false,
        configurable: true
    });
    PresetDriver.prototype.getBuiltCSS = function () {
        this.stylableDriver.writeFile(this.entryPath, this.generatedSheet.source);
        return this.stylableDriver.buildCSS({
            emitBuild: false,
            entries: [this.entryPath],
        });
    };
    PresetDriver.prototype.getPresetIdList = function (presetList) {
        var _this = this;
        if (presetList === void 0) { presetList = 'static'; }
        switch (presetList) {
            case 'static':
                return this.presets.staticPresets.map(function (_value, index) {
                    return _this.presetClassName(exports.STATIC_PRESET_CLASS_PREFIX + index);
                });
            case 'user':
                return this.presets.myPresets.map(function (_value, index) {
                    return _this.presetClassName(exports.USER_PRESET_CLASS_PREFIX + index);
                });
            case 'theme':
                return this.presets.themePresets.map(function (_value, index) {
                    return _this.presetClassName(exports.THEME_PRESET_CLASS_PREFIX + index);
                });
        }
    };
    Object.defineProperty(PresetDriver.prototype, "rootClassName", {
        get: function () {
            return this.presetClassName('root');
        },
        enumerable: false,
        configurable: true
    });
    PresetDriver.prototype.removeAllSelectorRules = function (selector) {
        var _this = this;
        if (!this.variantDriver || !this.workingStylesheet) {
            return;
        }
        this.stylableDriver.batch(this.entryPath, function () {
            var rules = _this.variantDriver.getVariantStyleRules(selector);
            rules.forEach(function (rule) { return _this.workingStylesheet.removeRule(rule); });
        });
    };
    PresetDriver.prototype.applyPresetToWorkingStylesheet = function (presetIndex, fromPresetList) {
        if (fromPresetList === void 0) { fromPresetList = 'static'; }
        var selector = '.' + this.sourceClassName;
        // Save previous st-mixin data:
        if (!this.shouldRestorePreset) {
            this.shouldRestorePreset = true;
            this.savedRules = this.variantDriver && this.variantDriver.getVariantStyleRules(selector); // save current rules
        }
        var currentExtends = this.extendsSymbol || exports.getClassnameExtends(this.workingStylesheet, this.sourceClassName);
        if (!currentExtends) {
            return;
        }
        var targetStylesheet = this.workingStylesheet;
        if (fromPresetList === 'static') {
            this.removeAllSelectorRules(selector);
            var preset = this.presets.staticPresets[presetIndex];
            var stylesheetId = targetStylesheet.upsertImport({
                path: preset.path,
                requestedDefaultImportName: this.componentName,
            }).default;
            targetStylesheet.upsertStyleRule(selector);
            targetStylesheet.upsertDeclarationToRule(selector, {
                prop: core_1.valueMapping.mixin,
                value: "" + stylesheetId,
            });
            targetStylesheet.upsertDeclarationToRule(selector, {
                prop: core_1.valueMapping.extends,
                value: currentExtends,
            });
        }
        else {
            // Save preset data
            var presetList = fromPresetList === 'user' ? this.presets.myPresets : this.presets.themePresets;
            var sourceSelector_1 = '.' + presetList[presetIndex].named;
            var presetVariantDriver = this.getPresetVariantDriver(presetList[presetIndex].path);
            var rulesFromPreset = presetVariantDriver ? presetVariantDriver.getVariantStyleRules(sourceSelector_1) : [];
            this.removeAllSelectorRules(selector);
            rulesFromPreset.forEach(function (rule) {
                var newSelector = rule.selector.replace(sourceSelector_1, selector);
                var newRule = rule.clone({ selector: newSelector });
                targetStylesheet.addRule(newRule);
            });
        }
    };
    PresetDriver.prototype.restorePreset = function () {
        var _this = this;
        if (!this.shouldRestorePreset) {
            return;
        }
        var selector = '.' + this.sourceClassName;
        this.removeAllSelectorRules(selector); // remove current rules
        this.workingStylesheet && this.savedRules.forEach(function (rule) { return _this.workingStylesheet.addRule(rule); }); // add saved ones
        this.clearRestore();
    };
    PresetDriver.prototype.clearRestore = function () {
        this.savedRules = [];
        this.shouldRestorePreset = false;
    };
    PresetDriver.prototype.presetClassName = function (className) {
        return this.stylableDriver.getTargetClass(this.entryPath, className);
    };
    PresetDriver.prototype.initStylesheets = function (params) {
        if (params.sheetPath) {
            this.workingStylesheet = this.stylableDriver.getStylesheet(params.sheetPath);
            this.variantDriver = new stylable_variant_1.StylableVariant(this.workingStylesheet);
            this.presetSheetPaths = [params.sheetPath];
        }
        if (params.presetSheetPaths) {
            this.presetSheetPaths = params.presetSheetPaths;
        }
        this.generateStylesheet();
    };
    PresetDriver.prototype.generateStylesheet = function () {
        var _this = this;
        this.entryPath = "/" + this.componentName + "-presets.st.css";
        this.stylableDriver.writeFile(this.entryPath, '');
        this.generatedSheet = this.stylableDriver.getStylesheet(this.entryPath);
        this.presets.staticPresets.map(function (preset, index) {
            var localMixinName;
            if (preset.named) {
                _this.generatedSheet.upsertImport({
                    path: preset.path,
                    named: [preset.named],
                });
                localMixinName = preset.named;
            }
            else {
                var d = _this.generatedSheet.upsertImport({
                    path: preset.path,
                }).default;
                localMixinName = d;
            }
            _this.generatedSheet.upsertStyleRule(".preset" + index);
            _this.generatedSheet.upsertDeclarationToRule(".preset" + index, {
                prop: core_1.valueMapping.mixin,
                value: "" + localMixinName,
            });
        });
        this.presetSheetPaths.forEach(function (presetPath) {
            var presetStylesheet = _this.stylableDriver.getStylesheet(presetPath);
            if (!presetStylesheet) {
                return;
            }
            var _a = _this.getPresetsFromStyleSheet(presetStylesheet), themePresets = _a.themePresets, myPresets = _a.myPresets;
            var presetsFromWorkingStyleSheet = themePresets.concat(myPresets);
            var named = _this.generatedSheet.upsertImport({
                path: presetPath,
                named: presetsFromWorkingStyleSheet,
            }).named;
            var sitePresets = Object.keys(named) || [];
            sitePresets.forEach(function (className) {
                if (themePresets.indexOf(className) !== -1) {
                    _this.addPresetToList(className, "." + exports.THEME_PRESET_CLASS_PREFIX, presetPath, _this.presets.themePresets);
                }
                else {
                    _this.addPresetToList(className, "." + exports.USER_PRESET_CLASS_PREFIX, presetPath, _this.presets.myPresets);
                }
            });
        });
    };
    PresetDriver.prototype.addPresetToList = function (className, selectorPrefix, path, presetList) {
        var index = presetList.length;
        presetList.push({ named: className, path: path });
        this.generatedSheet.upsertStyleRule("" + selectorPrefix + index);
        this.generatedSheet.upsertDeclarationToRule("" + selectorPrefix + index, {
            prop: core_1.valueMapping.mixin,
            value: className,
        });
    };
    PresetDriver.prototype.getPresetsFromStyleSheet = function (stylesheet) {
        var _this = this;
        var themePresets = [];
        var myPresets = [];
        if (!stylesheet) {
            return { themePresets: themePresets, myPresets: myPresets };
        }
        var currentExtends = this.extendsSymbol || exports.getClassnameExtends(this.workingStylesheet, this.sourceClassName);
        var rules = stylesheet &&
            stylesheet.AST.nodes &&
            stylesheet.AST.nodes.filter(function (rule) {
                return rule.type === 'rule' &&
                    rule.nodes &&
                    rule.nodes.find(function (decl) {
                        return decl.type === 'decl' && decl.prop === core_1.valueMapping.extends && decl.value === currentExtends;
                    });
            });
        rules &&
            rules.forEach(function (rule) {
                var targetList;
                if (rule.type === 'rule') {
                    if (rule.nodes &&
                        rule.nodes.find(function (decl) {
                            return decl.type === 'decl' && decl.prop === exports.THEME_PRESET_PROPNAME && decl.value === 'true';
                        })) {
                        // rule has editor theme true:
                        targetList = themePresets;
                    }
                    else {
                        targetList = myPresets;
                    }
                    var selector = rule.selector[0] === '.' ? rule.selector.slice(1, rule.selector.length) : rule.selector;
                    if (selector !== _this.sourceClassName && selector !== 'root') {
                        targetList.push(selector);
                    }
                }
            });
        return { themePresets: themePresets, myPresets: myPresets };
    };
    PresetDriver.prototype.getPresetVariantDriver = function (path) {
        var stylesheet = this.stylableDriver.getStylesheet(path);
        return stylesheet ? new stylable_variant_1.StylableVariant(stylesheet) : undefined;
    };
    return PresetDriver;
}());
exports.PresetDriver = PresetDriver;
//# sourceMappingURL=preset-driver.js.map